/** @module csi/view/customview/SelectController */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"./_DefaultControllerMixin"
], function(declare, Controller, _DefaultControllerMixin) {

	return declare([Controller, _DefaultControllerMixin], {
		/**
		 * Write operations to save newly selected custom view as default, either for current user or site if only managing site-level views
		 */
		toWriter: function() {
			const {actionValue} = this;
			const defaultUrl = this._getDefaultUrl();

			if (actionValue && (actionValue != defaultUrl)) {
				this._writeDefault(actionValue);
			}
		},

		/**
		 * Apply new custom view to view
		 */
		postProcessSuccess: function() {
			const {actionValue, widget} = this;

			if (actionValue !== widget.customViewId) {
				widget.set("customViewDirty", false);
				widget.set("customViewId", actionValue);
				widget.refreshDefaultCustomView();
			}
		}
	});
});